import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface CoupeDefaultIconProps {
  color?: Color;
}

const CoupeDefaultIcon: React.FC<CoupeDefaultIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M64.5501 29.01C64.5501 29.01 69.12 28.54 69.99 28.36C70.862 28.0495 71.6213 27.4854 72.1701 26.74C72.4439 25.6712 72.4848 24.5561 72.2901 23.47C72.1501 23.04 71.6901 22.99 71.5501 22.62C71.4101 22.25 71.1801 19.3 71.1401 18.76C70.9968 18.0644 70.6234 17.4374 70.0801 16.9801C69.5801 16.5701 64.8901 16.1201 64.4301 15.9801C63.9701 15.8401 55.7 13.6601 53.1 13.0401C50.5 12.4201 39.8801 12.04 36.5901 12.64C32.2808 13.553 28.1518 15.1714 24.37 17.43C15.37 17.71 9.52012 19.38 8.82012 19.65C8.12012 19.92 5.12014 21.34 4.59014 23.36C4.11014 25.21 4.52008 28.92 4.90008 29.02C5.28008 29.12 10.2201 29.84 10.2201 29.84"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path d="M24.59 29.35H50.25" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
    <path
      d="M26.9 18.27C31.38 18.11 56.71 17.37 61.4 17.2"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path d="M48.22 13.51L47.46 17.63" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
    <path
      d="M12.4401 21.15C11.97 21.6624 11.545 22.2144 11.1701 22.8C11.1437 22.8456 11.1059 22.8835 11.0602 22.9099C11.0146 22.9362 10.9628 22.9501 10.9101 22.95C10.0701 22.95 7.9101 23.07 7.8101 22.84C7.75791 22.6545 7.75635 22.4583 7.80559 22.2719C7.85482 22.0855 7.9531 21.9157 8.09013 21.78C8.38013 21.6 9.09004 20.94 12.25 20.78C12.2979 20.7634 12.3501 20.7646 12.3971 20.7834C12.4442 20.8022 12.4828 20.8374 12.5059 20.8824C12.529 20.9275 12.5352 20.9793 12.5231 21.0285C12.511 21.0777 12.4815 21.1209 12.4401 21.15Z"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M71.1601 18.76C71.1601 18.76 68.9201 18.76 68.7101 18.82C68.5001 18.88 68.1301 18.96 68.2601 19.3C68.4067 19.748 68.5907 20.1829 68.8101 20.6C68.8341 20.6396 68.8679 20.6723 68.9081 20.6951C68.9484 20.7178 68.9938 20.7299 69.0401 20.73C69.782 20.7354 70.5224 20.665 71.25 20.52"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M22.41 27.3C22.4704 28.3216 22.2256 29.338 21.7069 30.2202C21.1881 31.1023 20.4188 31.8102 19.4967 32.254C18.5746 32.6978 17.5413 32.8574 16.5283 32.7125C15.5153 32.5676 14.5683 32.1248 13.8076 31.4403C13.0469 30.7558 12.5068 29.8605 12.2562 28.8683C12.0055 27.8761 12.0555 26.8318 12.3999 25.8682C12.7442 24.9045 13.3674 24.065 14.19 23.4564C15.0127 22.8477 15.9977 22.4974 17.02 22.45C18.2683 22.399 19.4943 22.7923 20.4799 23.56"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M63.1 27.32C63.1604 28.3416 62.9158 29.358 62.397 30.2401C61.8783 31.1222 61.1089 31.8302 60.1868 32.274C59.2647 32.7178 58.2315 32.8774 57.2184 32.7325C56.2054 32.5876 55.2583 32.1447 54.4976 31.4602C53.7369 30.7757 53.1969 29.8805 52.9462 28.8883C52.6956 27.8961 52.7457 26.8519 53.09 25.8882C53.4344 24.9245 54.0574 24.085 54.88 23.4763C55.7027 22.8677 56.6879 22.5174 57.7101 22.47C58.9585 22.419 60.1844 22.8123 61.1701 23.58"
      stroke={color}
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
  </svg>
);

export default CoupeDefaultIcon;
